import { render } from "./InnovacioView.vue?vue&type=template&id=578131b8"
import script from "./InnovacioView.vue?vue&type=script&lang=js"
export * from "./InnovacioView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__